import React, { Component } from "react";
import { Map, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import iconUrl from "leaflet/dist/images/marker-icon.png";
import iconShadowUrl from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl,
  shadowUrl: iconShadowUrl,
});

class SelectionMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      position: null,
      selected: props.initialPosition || null,
      searchQuery: "",
      loading: false,
    };
  }

  componentDidMount() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.setState({
            position: [pos.coords.latitude, pos.coords.longitude],
          });
        },
        () => {
          this.setState({ position: [19.4326, -99.1332] });
        }
      );
    } else {
      this.setState({ position: [19.4326, -99.1332] });
    }
  }

  handleMapClick = (e) => {
    const { lat, lng } = e.latlng;
    this.setState({ selected: [lat, lng] });
    if (this.props.onSelect) this.props.onSelect(lat, lng);
  };

  handleMarkerDragEnd = (e) => {
    const marker = e.target;
    const position = marker.getLatLng();
    this.setState({ selected: [position.lat, position.lng] });
    if (this.props.onSelect) this.props.onSelect(position.lat, position.lng);
  };

  handleSearch = async () => {
    const { searchQuery } = this.state;
    if (!searchQuery.trim()) return;

    this.setState({ loading: true });

    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
          searchQuery
        )}`
      );
      const data = await response.json();

      if (data && data.length > 0) {
        const { lat, lon } = data[0];
        this.setState({
          selected: [parseFloat(lat), parseFloat(lon)],
          position: [parseFloat(lat), parseFloat(lon)],
        });
        if (this.props.onSelect) this.props.onSelect(lat, lon);
      } else {
        alert("Dirección no encontrada");
      }
    } catch (err) {
      console.error("Error al buscar dirección:", err);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { currPosition } = this.props;
    const { position, selected, searchQuery, loading } = this.state;

    if (!position)
      return <p style={{ textAlign: "center" }}>Obteniendo ubicación...</p>;

    const lat = parseFloat((currPosition?.[0] || '').toString().replace(/,/g, ''));
    const lon = parseFloat((currPosition?.[1] || '').toString().replace(/,/g, ''));
    const isValidCoords = !isNaN(lat) && !isNaN(lon) && lat >= -90 && lat <= 90 && lon >= -180 && lon <= 180;
    const markerPosition = selected || (isValidCoords ? [lat, lon] : position);

    return (
      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>

        <div className="input-group mb-3">
          <input
            id="rfcB"
            className="form-control"
            onChange={(e) => this.setState({ searchQuery: e.target.value })}
            value={searchQuery}
            placeholder="Buscar dirección..."
          />
          <button
            type="button"
            className="btn btn-outline-warning"
            onClick={this.handleSearch}
            disabled={loading}
            title="Buscar"
          >
            {loading ? (
              <i className="fa fa-spinner fa-spin" />
            ) : (
              <i className="fa fa-search" />
            )}
          </button>
        </div>


        <div style={{ flex: 1, position: "relative" }}>

          {loading && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                background: "rgba(255,255,255,0.8)",
                borderRadius: "50%",
                padding: "20px",
                zIndex: 1000,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  border: "4px solid #ccc",
                  borderTop: "4px solid #f0ad4e",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                }}
              ></div>
            </div>
          )}

          <Map
            center={markerPosition}
            zoom={15}
            style={{ height: "100%", width: "100%" }}
            onClick={this.handleMapClick}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution="&copy; OpenStreetMap contributors"
            />

            <Marker
              position={markerPosition}
              draggable={true}
              onDragEnd={this.handleMarkerDragEnd}
            />
          </Map>
        </div>

        {/* <div
          style={{
            padding: "8px",
            textAlign: "center",
            background: "#fafafa",
          }}
        >
          <strong>Coordenadas:</strong>{" "}
          {selected
            ? `${selected[0].toFixed(6)}, ${selected[1].toFixed(6)}`
            : "Selecciona un punto"}
        </div> */}

        <style>
          {`
            @keyframes spin {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }
}

export default SelectionMap;
